// extracted by mini-css-extract-plugin
module.exports =  {"handshakeCard":"handshake_card-module_handshakeCard_b259b","title":"handshake_card-module_title_d332f","body":"handshake_card-module_body_fd2b8"};